//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            conversionChartData: [["Opened", 0], ["Archived", 0]],
            stageChartData: [["Pending", 0], ["Background", 0], ["Credit", 0]],
            residents: 'Loading...',
            applicantCount: 0,
            guests: 0,
            property: {}
        };
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;
        axios.get('/prototype/properties/residents').then(function (response) {
            return _this.residents = response.data.length;
        });
        axios.get('/prototype/properties/stats').then(function (response) {
            return _this.property = response.data;
        });
        axios.get("/prototype/person/person-dashboard-chart").then(function (response) {
            $el.conversionChartData = response.data[0];
            $el.stageChartData = response.data[1];
            $el.applicantCount = response.data[2];
            $el.guests = response.data[3];
        });
    },

    computed: {
        pieChartData: function pieChartData() {
            return [['Leased', this.property.leasedUnitsCount], ['Vacant', (this.property.units && this.property.units.length > 0 ? this.property.units.length : 0) - this.property.leasedUnitsCount]];
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/PersonDashboard.vue
// module id = 0ynV
// module chunks = 0 1